const CSS_CLASSES = {
	ROOT: 'popupiconbutton',
};

export { CSS_CLASSES };
